/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { RefObject } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'

import { CSSTransition } from 'react-transition-group'
import { messageSelectors } from 'store/messages'
import { TranslationService as T } from 'utils/TranslationService'

import WidgetButton from 'components/shared/WidgetButton'
import { SendIcon } from 'components/customIcons'
import { TypingBubbles } from 'components/shared/TypingBubbles'
import TriggerWrapper from './TriggerWrapper'
import { TriggerText } from './TriggerText'

type Props = {
	reference: RefObject<HTMLDivElement>
}

const Trigger = ({ reference }: Props) => {
	const lastUnreadTrigger = useSelector(messageSelectors.lastUnreadTriggerMessage)
	const showTyping = useSelector(messageSelectors.showTriggerTypingAnimation)

	return showTyping ? (
		<TriggerWrapper reference={reference}>
			<TypingBubbles darker py={3} />
		</TriggerWrapper>
	) : (
		lastUnreadTrigger && (
			<CSSTransition timeout={300}>
				<TriggerWrapper renderCloseButton reference={reference}>
					<TriggerText />
					<Box pb={1} display="flex" justifyContent="center" width="100%">
						<WidgetButton
							css={triggerButtonCss}
							data-testid="triggerButton"
							startIcon={<SendIcon customFontSize={15} />}
						>
							{T.translate('trigger.openChatButton')}
						</WidgetButton>
					</Box>
				</TriggerWrapper>
			</CSSTransition>
		)
	)
}

const triggerButtonCss = css({
	width: '90%',
})

export default Trigger
